import { ChainId } from '../sdk/chainId'

import { CHAINS } from './chains/index'
import type { ChainDefinition } from './types'

function parseEnvChainId(): number | undefined {
  const raw = import.meta.env.VITE_CHAIN_ID
  if (raw === undefined || raw === '') return undefined
  const n = Number.parseInt(String(raw), 10)
  return Number.isFinite(n) ? n : undefined
}

/** Resuelve el `chainId` de despliegue (env o Creative por defecto). */
export function getActiveChainId(): ChainId {
  const fromEnv = parseEnvChainId()
  const candidate = fromEnv ?? ChainId.INFINITE_CREATIVE
  const def = CHAINS[candidate as ChainId]
  if (def?.configured) {
    return def.chainId
  }
  const creative = CHAINS[ChainId.INFINITE_CREATIVE]
  if (creative.configured) {
    return ChainId.INFINITE_CREATIVE
  }
  throw new Error('[config] No hay ninguna cadena configurada en CHAINS')
}

export function getChain(chainId: ChainId): ChainDefinition {
  const def = CHAINS[chainId]
  if (!def) {
    throw new Error(`[config] chainId desconocido: ${chainId}`)
  }
  return def
}

export function getActiveChain(): ChainDefinition {
  return getChain(getActiveChainId())
}
